import GroupChangeFounderModalContainer from './GroupChangeFounderModal.container';
import GroupChangeFounderModal from './GroupChangeFounderModal';

export default GroupChangeFounderModalContainer(GroupChangeFounderModal);
